import React from 'react';
import { Container, Col } from 'reactstrap';
import { RecipeForm } from '../Form';
import { RouteComponentProps } from 'react-router-dom';
import { Recipe } from 'state/recipe/model';

interface State {
  units: string[]
}

interface Props extends RouteComponentProps<any> {
  recipe: Recipe,
  setActiveRecipe(recipe: Recipe): void,
  fetchRecipe(id: string): Promise<Recipe>,
  unSetActiveRecipe(): void,
  updateRecipe(recipe: Recipe): void
}

export default class EditRecipe extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      units: []
    }
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    this.props.fetchRecipe(id);
  }

  onSubmit = (values: Recipe) => {
    this.props.updateRecipe(values);
  }

  render() {
    return (
      <div>
        <Container>
          <Col md={10}>
            <h1>Recipe: </h1>
            <RecipeForm
              defaultValue={this.props.recipe}
              onSubmit={this.onSubmit}
              location={this.props.location.pathname}
            />
          </Col>
        </Container>
      </div>
    )
  }
}